/**
 * cachr.ts - Cachr (Cache Management) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const cachrModule = {
  id: 'infra-cachr',
  name: 'Cache Management',
  icon: '💾',
  category: 'modules',
  order: 20,
  
  packageInfo: {
    name: '@opcentral/cachr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Cache management with LRU eviction - platform-agnostic core with React wrapper',
    status: 'in-progress',
    implementationProgress: 80,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*'
    },
    keywords: ['cache', 'lru', 'performance', 'storage'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    enableCaching: {
      type: 'boolean',
      label: 'Enable Caching',
      description: 'Use cache for improved performance',
      defaultValue: true
    },
    
    maxCacheSize: {
      type: 'number',
      label: 'Max Cache Size (MB)',
      description: 'Maximum cache size in megabytes',
      defaultValue: 100,
      min: 10,
      max: 1000,
      visible: (settings) => settings['infra-cachr.enableCaching']
    },
    
    defaultTTL: {
      type: 'number',
      label: 'Default TTL (seconds)',
      description: 'Default time-to-live for cached items',
      defaultValue: 3600,
      min: 60,
      max: 86400,
      visible: (settings) => settings['infra-cachr.enableCaching']
    },
    
    evictionStrategy: {
      type: 'select',
      label: 'Eviction Strategy',
      description: 'How to remove items when cache is full',
      defaultValue: 'lru',
      options: [
        { label: 'LRU (Least Recently Used)', value: 'lru' },
        { label: 'LFU (Least Frequently Used)', value: 'lfu' },
        { label: 'FIFO (First In First Out)', value: 'fifo' }
      ],
      visible: (settings) => settings['infra-cachr.enableCaching']
    }
  }
};

export default cachrModule;
